<template>
  <div class="designer position-relative">
    <div class="row">
      <div class="col">
        <section-header tag="h1" class="mt-5 mb-5" title="設計師總覽" subtitle="Designers"/>
        <section class="row mb-5" v-for="(category, indexCate) in designerCategories" :key="`category-${indexCate}`">
          <div class="col-12 mb-3">
            <div class="title border-bottom border-secondary" :id="category.title">{{ category.title }}</div>
          </div>
          <div class="col-12">
            <div class="content" v-for="(designer, indexDes) in category.items" :key="`designer-${indexDes}`">
              <router-link :to="`/w/designer/detail/${designer.designerId}`" class="text-decoration-none text-dark">{{ designer.designerName }}</router-link>
            </div>
          </div>
        </section>
      </div>
      <div class="col-auto p-0">
        <div class="index">
          <div class="" v-for="(category, index) in designerCategories" :key="`index-${index}`">
            <a class="text-center text-decoration-none text-dark" :href="`#${category.title}`">{{ category.title }}</a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import constant from '@/constant.js'
import designerApi from '@/api/designer.js'
import { mapMutations } from 'vuex'
import SectionHeader from '@/components/SectionHeader.vue'

export default {
  name: 'Designer',
  components: {
    SectionHeader
  },
  data: function () {
    return {
      designers: []
    }
  },
  computed: {
    designerCategories: function () {
      var ret = []
      if (this.designers) {
        this.designers.forEach(designer => {
          if (designer && designer.isShow) {
            var head = designer.designerName[0].toLocaleUpperCase()
            if (head < 'A' || head > 'Z') {
              head = '#'
            }
            var category = ret.find(e => (e.title === head))
            if (category) {
              category.items.push(designer)
            } else {
              ret.push({ title: head, items: [designer] })
            }
          }
        })
      }
      ret.sort((a, b) => (a.title < b.title ? -1 : a.title > b.title ? 1 : 0))
      return ret
    }
  },
  mounted: function () {
    this.apiGetDesigners()
  },
  methods: {
    ...mapMutations([
      'signOut'
    ]),
    apiGetDesigners: function () {
      var self = this
      designerApi.getDesigners(function (err, rspData) {
        if (err) {
          if (err === constant.API_ERR_AUTH) {
            self.signOut()
          } else {
            alert(`${err}: ${rspData}`)
          }
          return
        }
        self.designers = rspData
      })
    }
  }
}
</script>

<style scoped>
.title {
  font-size: 4.2rem;
  font-weight: 700;
}
.content {
  font-size: 1.5rem;
}
.index {
  padding: 1rem 2rem;
  position: sticky;
  top: 0;
  text-align: center;
  overflow-y: auto;
  height: 100vh;
  font-size: 1.125rem;
  font-weight: 700;
}
</style>
